import { getAuthorizationProvider } from "../Authentication";

const callGraphApi = async (url) => {
  var provider = await getAuthorizationProvider();
  let scopes = ["User.Read"];

  try {
    var accounts = provider.getAllAccounts();
    if (!accounts || accounts.length === 0) {
      await provider.loginRedirect({ scopes: scopes });
      return null;
    }

    var token = await provider.acquireTokenSilent({ scopes: scopes, account: accounts[0] });
    var headers = new Headers();
    headers.append("Authorization", `Bearer ${token.accessToken}`);
    try {
      var response = await fetch(url, { method: 'GET', headers: headers });
      var data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  } catch (e) {
    await provider.acquireTokenRedirect({ scopes: scopes });
  }
};

export const fetchCurrentUser = async () => {
  var user = await callGraphApi("https://graph.microsoft.com/v1.0/me");
  return user;
};

export const fetchUserGroups = async () => {
  let groups = [];
  let url = "https://graph.microsoft.com/v1.0/me/memberOf";
  while (url) {
    const data = await callGraphApi(url);
    if (data?.value) {
      groups = groups.concat(
        data.value.map(g => ({
          id: g.id,
          name: g.displayName
        }))
      );
    }
    url = data?.["@odata.nextLink"] ?? null;
  }
  return groups;
};
